import { render, staticRenderFns } from "./SurveyPresentation.vue?vue&type=template&id=204aa0ad&scoped=true&"
import script from "./SurveyPresentation.vue?vue&type=script&lang=js&"
export * from "./SurveyPresentation.vue?vue&type=script&lang=js&"
import style0 from "./SurveyPresentation.vue?vue&type=style&index=0&id=204aa0ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204aa0ad",
  null
  
)

export default component.exports